import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { appStore, timStore } from "@/hooks";
import {
  PanelCard,
  TypeDirectionInput,
  TypeIconInput,
  DetailsPanel,
  FlexBox,
  TextButton,
  Icon,
  Separator,
  Typography,
  TypeColorInput,
} from "@/components/common";


/**
 * Allows for editing the artifact level information.
 */
const __default__ = {
  name: "SaveArtifactLevelPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const artifactLevel = computed(() => timStore.selectedArtifactLevel);
const name = computed(() => artifactLevel.value?.name || "");
const iconId = computed(() => timStore.getTypeIcon(name.value));
const iconColor = computed(() => timStore.getTypeColor(name.value));

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createBlock(_unref(DetailsPanel), {
    panel: "saveArtifactLevel",
    "data-cy": "panel-save-artifact-type"
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        text: "",
        label: "View Type",
        icon: "artifact",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).openDetailsPanel('displayArtifactLevel')))
      })
    ]),
    default: _withCtx(() => [
      (artifactLevel.value)
        ? (_openBlock(), _createBlock(_unref(PanelCard), {
            key: 0,
            "data-cy": "panel-artifact-type-options",
            borderless: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FlexBox), {
                align: "center",
                justify: "between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Typography), {
                    ellipsis: "",
                    variant: "subtitle",
                    el: "h1",
                    value: name.value,
                    "data-cy": "text-selected-name"
                  }, null, 8, ["value"]),
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(name.value), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Icon), {
                    id: iconId.value,
                    size: "md",
                    color: iconColor.value
                  }, null, 8, ["id", "color"])
                ]),
                _: 1
              }),
              _createVNode(_unref(Separator), { b: "2" }),
              _createVNode(_unref(TypeDirectionInput), { "artifact-type": artifactLevel.value }, null, 8, ["artifact-type"]),
              _createVNode(_unref(TypeIconInput), { "artifact-type": artifactLevel.value }, null, 8, ["artifact-type"]),
              _createVNode(_unref(TypeColorInput), { "artifact-type": artifactLevel.value }, null, 8, ["artifact-type"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})